namespace Areas.Ucla {
    "use strict";

    export function supersededByValueChanged(args, setValueMethod) {
        setValueMethod(args.value);
    }

    export function onSelectionChanged(e, dropDownBoxInstance) {
        var key = e.selectedRowKeys[0];
        dropDownBoxInstance.option("value", key);
    }

    export function onCloseBtnClick(args, dropDownBoxInstance) {
        dropDownBoxInstance.close();
    }
    
    export function newDaUclaSupersededBy(e: any) {
        const dataGrid = e.component;
        e.data.daUclaId = dataGrid.option("DaUclaId");
    }
}